import { Button, cx } from '@otter-ai/den-components';
import { CardsIcon } from '@otter-ai/den-icons';

type TemplateListEmptyStateProps = {
  canCreateTemplate?: boolean;
  disabled?: boolean;
  navigate: () => void;
};
export function TemplateListEmptyState(props: TemplateListEmptyStateProps) {
  const { disabled, canCreateTemplate, navigate } = props;
  return (
    <div className="flex-col flex justify-center items-center py-6 px-12 min-h-[75vh]">
      <CardsIcon className="mb-3" />
      <span className="font-semibold mb-6">
        Create a template to customize meeting summaries.
      </span>
      {canCreateTemplate && (
        <Button
          variant="outlinePrimary"
          version="legacy"
          className="rounded-md"
          onClick={navigate}
          disabled={disabled}
        >
          <span className={cx(!disabled && 'text-primary')}>New Template</span>
        </Button>
      )}
    </div>
  );
}
